import { ListSteps } from "../../shared/list-steps";
import { PromptBig } from "../../shared/prompt-big";
import { Layout } from "./layout";
import { Prompt } from "./prompt";

export function PageTemplate(
	options: Prompt.Props & {
		/**
		 * @default `undefined`
		 * If defined will use the alternate prompt layout.
		 */
		steps?: ListSteps.Props["items"];
		/**
		 * @default `false`
		 * If `true` close will be will be labelled "Cancel" not be a primary
		 * action even if it's the only action.
		 */
		intermediate?: boolean;
	},
) {
	const { steps, intermediate, ...prompt } = options;
	return (props: {
		onClose?: () => void;
		onTimeout?: () => void;
		onRetry?: () => void;
		cancelling?: boolean;
	}) => {
		const { onClose, onRetry, onTimeout, cancelling } = props;
		// Only result/error screens auto-dismiss. Transaction-event screens
		// (`intermediate`) must never self-close while awaiting the terminal, so
		// they get no timeout unless one is passed explicitly.
		const timeoutCallback = onTimeout ?? (intermediate ? undefined : onClose);
		return (
			<Layout
				logo
				actionsStyle="full-width"
				onClose={onClose}
				timeout={timeoutCallback && { onTimeout: timeoutCallback }}
				pending={cancelling ? "close" : undefined}
				actions={[
					onRetry && { label: "Try Again", onClick: onRetry, primary: true },
					!intermediate && onClose
						? {
								label: "Close",
								onClick: onClose,
								primary: !onRetry,
							}
						: undefined,
				]}
			>
				{steps ? (
					<PromptBig
						{...prompt}
						message={
							<>
								{prompt.message}
								<ListSteps items={steps} />
							</>
						}
					/>
				) : (
					<Prompt {...prompt} />
				)}
			</Layout>
		);
	};
}
